import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

[popover] {
  position: unset;
  inset: unset;
  width: unset;
  height: unset;
  margin: unset;
  border: unset;
  padding: unset;
  color: unset;
  background-color: unset;
  overflow: unset;
}

/* ------------------------------------*\
 #DATERANGEPICKER-FIELD
\*------------------------------------ */
.cat-c-daterangepicker-field {
  width: var(--cat-date-range-picker--width, 100%);
  max-width: 100%;
  --cat-input-pointer-events: auto;
  --cat-input-field-readonly--border-color: var(--cat-theme-color-form-border);
  /**
   * Disabled state
   */
  /**
  * Padding for input field in warning and error state 
  */
}
.cat-c-daterangepicker-field.cat-c-daterangepicker-field--with-timeselector {
  width: calc(var(--size-base-unit) * 50.75);
}
.cat-c-daterangepicker-field.cat-c-daterangepicker-field--full-width {
  width: 100%;
}
.cat-c-daterangepicker-field.cat-c-daterangepicker-field--disabled {
  --cat-input-field-readonly--border-color: var(--cat-theme-color-border-disabled);
}
.cat-c-daterangepicker-field.cat-c-daterangepicker-field--disabled:hover {
  cursor: not-allowed;
}
.cat-c-daterangepicker-field.cat-c-daterangepicker-field--disabled cat-combined-input {
  pointer-events: none;
}
.cat-c-daterangepicker-field.cat-c-daterangepicker-field--readonly {
  pointer-events: none;
  --cat-input-pointer-events: none;
  --cat-input-field-readonly--border-color: var(--cat-theme-color-border-readonly);
  --cat-input-field-readonly--icon-color: var(--cat-theme-color-content-disabled);
}
.cat-c-daterangepicker-field.cat-is-warning, .cat-c-daterangepicker-field.cat-is-error {
  --cat-input-padding-horiz-end: var(--cat-space-6x-large);
}

/**
 * Datepicker container wrapper
 */
.cat-c-daterangepicker-field__body {
  position: relative;
}

.cat-c-daterangepicker-field__popup-wrapper {
  display: none;
  z-index: var(--cat-z-index-400);
}

/**
 * Popup body, containing the calendar w/ optional time selector list
 */
.cat-c-daterangepicker-field__popup-body {
  box-shadow: var(--cat-theme-box-shadow-lg);
  border-radius: var(--cat-border-radius-lg);
  background-color: var(--cat-theme-color-background-default);
  pointer-events: auto;
  max-height: var(--cat-auto-position-max-height);
  max-width: var(--cat-auto-position-max-width);
  overflow: var(--cat-auto-position-overflow);
}

.cat-c-daterangepicker-field__calendar-start:focus,
.cat-c-daterangepicker-field__calendar-end:focus {
  outline: none;
}

/**
 * Calendar w/ optional time selector list container
 */
.cat-c-daterangepicker-field__calendar:not([hidden]) {
  /**
   * Popup body on large screens
   * 1) Position for calendar with time selector at larger screens
   */
}
.cat-c-daterangepicker-field--with-timeselector:not(.cat-c-daterangepicker-field--small-screen) .cat-c-daterangepicker-field__calendar:not([hidden]) {
  display: grid;
  column-gap: var(--cat-space-x-small);
  grid-template-columns: minmax(auto, 25rem) auto; /* 1 */
}

/**
 * Container for time selector list component
 * 1) Declare explicit dimensions for smaller screens
 */
.cat-c-daterangepicker-field--small-screen .cat-c-daterangepicker-field__time-selector-container {
  width: calc(var(--size-base-unit) * 40); /* 1 */
  overflow: hidden;
  border-block-start: 1px solid var(--cat-theme-color-border-default);
}

/**
 * Popup footer
 */
.cat-c-daterangepicker-field__footer {
  border-block-start: 1px solid var(--cat-theme-color-border-default);
  padding: var(--cat-space-medium);
  grid-column-start: span 2;
  display: flex;
  gap: var(--cat-space-medium);
  min-width: calc(var(--size-base-unit) * 40);
}

cat-time-selector-list {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/**
 * Accessibility instructions
 */
.cat-c-daterangepicker-field__instructions {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.cat-c-daterangepicker-field__button {
  margin-inline-end: var(--cat-space-medium);
}

.cat-c-daterangepicker-field__button_container {
  display: flex;
}

/**
 * Apply  loaders  style
 */
.cat-c-daterangepicker-field--loader {
  display: flex;
  flex-direction: column;
  gap: var(--cat-space-3x-small);
}
.cat-c-daterangepicker-field--loader .cat-c-daterangepicker__input-loader-container {
  display: flex;
  gap: var(--cat-space-3x-small);
}
.cat-c-daterangepicker-field--loader .cat-c-daterangepicker__input-loader-container .cat-c-daterangepicker__input-loader-wrapper {
  width: 50%;
  gap: 4px;
  display: flex;
  flex-direction: column;
}

.cat-c-daterangepicker__input-loader {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 3);
  position: relative;
}
.cat-c-daterangepicker__input-loader .cat-c-daterangepicker__icon-loader {
  position: absolute;
  inset-inline-end: var(--cat-space-medium);
  inset-block-end: calc(var(--size-base-unit) * 1.25);
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-daterangepicker-field--large .cat-c-daterangepicker__input-loader .cat-c-daterangepicker__icon-loader {
  inset-block-end: var(--cat-space-medium);
}
.cat-c-daterangepicker-field--medium .cat-c-daterangepicker__input-loader {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 2.5);
}
.cat-c-daterangepicker-field--small .cat-c-daterangepicker__input-loader {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 2);
}

.cat-c-daterangepicker-field:not(.cat-c-daterangepicker-field--has-field-note) .cat-c-daterangepicker-field__field-note-slot, .cat-c-daterangepicker-field:not(.cat-c-daterangepicker-field--has-error) .cat-c-daterangepicker-field__error-slot, .cat-c-daterangepicker-field:not(.cat-c-daterangepicker-field--has-warning) .cat-c-daterangepicker-field__warning-slot {
  display: none;
}
`;
       